export default "__VITE_ASSET__2AHHvLWa__"